import { ADD_PRODUCT, DECREMENT_STOCK, INCREMENT_STOCK } from "./actionTypes"

export const addProduct = (data) => {
    return {
        type: ADD_PRODUCT,
        payload: data
    }
} 

export const decrementStock = (product) => {
    return {
        type: DECREMENT_STOCK,
        payload: product
    }
}

export const incrementStock = (productId, amount) => {
    return {
        type: INCREMENT_STOCK,
        payload: {
            productId,
            amount
        }
    }
}